const handleVideoModal = (modal = '.js-popup-video') => {
	const $modal = $(modal);

	$modal.magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false
	});
}

handleVideoModal();
